import React from 'react';
import classNames from 'classnames';
import CheckboxField from 'components/CheckboxFieldGroup/CheckboxField';
import InputField from 'components/InputField';
import { Button } from 'ncoded-component-library';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { useTranslation } from 'react-i18next';
import validations from 'validations';
import ArrowrightIcon from 'icons/Arrowright.icon';
import PlusIcon from 'icons/Plus.icon';
import TrashIcon from 'icons/Trash.icon';
import { isSingleElementArray } from 'utils';

import './AutomationQuestion.styles.scss';

export const ADD_NEW_ANSWER_INITIAL = {
  text: '',
  advancesLead: false,
};

type AutomationQuestionProps = {
  className?: string;
  status: string;
  // The last stage has nowhere to move a lead, so answers can't progress.
  isLastStage?: boolean;
};

const AutomationQuestion: React.FC<AutomationQuestionProps> = (props) => {
  const { className, status, isLastStage } = props;

  const classes = classNames('automation-question', className);

  const { t } = useTranslation();

  return (
    <div>
      <div className={classes}>
        <div className="automation-question__section">
          <p className="automation-question__label">{t('question')}</p>

          <Field
            name="progressionQuestion.question"
            component={InputField}
            className="automation-question__input-field"
            validate={validations.required()}
          />
        </div>

        <div className="automation-question__section">
          <div className="automation-question__section-header">
            <p className="automation-question__label">{t('answerOptions')}</p>

            {!isLastStage && (
              <div className="automation-question__progress-target">
                <ArrowrightIcon />
                <span>{t('progressesToStatus', { status })}</span>
              </div>
            )}
          </div>

          <FieldArray
            name="progressionQuestion.answers"
            validate={(answers) => {
              if (!answers?.some(({ text }) => text?.trim()))
                return t('atLeastOneAnswer');
            }}
          >
            {({ fields, meta }) => (
              <div className="automation-question__answers">
                {fields.map((answerName, index) => (
                  <div key={answerName} className="automation-question__card">
                    <div className="automation-question__answer-card">
                      <Field
                        name={`${answerName}.text`}
                        component={InputField}
                        className="automation-question__input-field"
                      />

                      <div className="automation-question__answer-actions">
                        {!isLastStage && (
                          <Field
                            name={`${answerName}.advancesLead`}
                            component={CheckboxField}
                            type="checkbox"
                            label={t('progresses')}
                          />
                        )}

                        <Button
                          variant="icon"
                          type="button"
                          icon={TrashIcon}
                          className={classNames(
                            'automation-question__delete-button',
                            { visible: !isSingleElementArray(fields?.value) },
                          )}
                          onClick={() => fields.remove(index)}
                        />
                      </div>
                    </div>
                  </div>
                ))}

                {meta.touched && meta.error && (
                  <span className="automation-question__error">
                    {meta.error}
                  </span>
                )}

                <Button
                  variant="outline"
                  type="button"
                  icon={PlusIcon}
                  className="automation-question__add-answer-button"
                  onClick={() => fields.push(ADD_NEW_ANSWER_INITIAL)}
                >
                  {t('addAnswer')}
                </Button>
              </div>
            )}
          </FieldArray>
        </div>
      </div>
    </div>
  );
};

export default AutomationQuestion;
